import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Dialog } from 'primereact/dialog';

//Services
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { GETACCOUNTS, GETVOUCHERS, SAVEJVENTRY } from '../../../config/ApiConstant';
import { amountFormate, convertAccoutingYear, convertSingleYear, convertYearforAccouting } from '../../../appconfig/AppHelper';
import { AddJVEntryValidate } from '../../../config/Validate';
import { ACCOUNTTYPE, convertDateFrom, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { creditTemplate, debitTemplate, remarkTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { JVEntryAddListColumns } from '../../../appconfig/DatatableSetting';

export const AddJVEntry = () => {
    document.title = 'JV Entry | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    //Loading/Page Loading
    const [jvEntryData, setJVEntryData] = useState<any>({});
    const [date, setDate] = useState<any>(new Date());
    const [voucher, setVoucher] = useState<any>(null);
    const [accYear, setAccYear] = useState<any>(convertAccoutingYear(new Date()));
    const [accounts, setAccounts] = useState<any>([]);
    const [errors, setErrors] = useState<any>({});
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [jvEntryList, setJVEntryList] = useState<any>([]);
    const [credit, setCredit] = useState<any>(null);
    const [debit, setDebit] = useState<any>(null);
    const [isJVUIUpdated, setIsJVUiUpdated] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);

    //cr/dr type
    const [type, setType] = useState<any>(null);

    // useEffect
    useEffect(() => {
        // Get Accouting Year
        let year = convertSingleYear(date);
        getVoucher(year);
        getAllAccounts();
    }, []);

    useEffect(() => {
        if (!window.cn(jvEntryList) && jvEntryList.length > 0) {
            getAllTotals();
        }
    }, [jvEntryList]);

    useEffect(() => {
        if (isJVUIUpdated) {
            setIsJVUiUpdated(false);
            jvEntryUI();
        }
    }, [isJVUIUpdated]);

    // Get voucher
    const getVoucher = async (year: any) => {
        try {
            const response = await getAllDetailsDirect(GETVOUCHERS + '?year=' + year);
            if (response) {
                setVoucher(response.jv_ref);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all accounts
    const getAllAccounts = async () => {
        try {
            const response = await getAllDetailsDirect(GETACCOUNTS);
            if (response) {
                let accOption: any = [];
                response.List.map((option: any) => {
                    accOption.push({ name: option.AccName, code: option.SrNo });
                });
                setAccounts(accOption);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'accName') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setJVEntryData({ ...jvEntryData, [name]: val });
    };

    // handle change date
    const handleChangeDate = (val: any) => {
        setDate(val);
        let year = convertSingleYear(new Date(val));
        getVoucher(year);
    };

    // Clear all
    const clearAll = () => {
        let date = new Date();
        let year = date.getFullYear();
        setDate(new Date());
        getVoucher(year);
        setJVEntryData({
            accName: jvEntryData?.accName
        });
        setJVEntryList([]);
    };

    // Add JV entry
    const addJvEntry = () => {
        const { errors, isError } = AddJVEntryValidate(jvEntryData, type);
        setErrors(errors);
        //Check Error if no errors then call API
        if (!isError) {
            let tempJVEntryList = [...jvEntryList];

            tempJVEntryList.push({
                CurrDate: convertDateFrom(date),
                CusSrno: jvEntryData?.accName.code,
                Prefix: convertYearforAccouting(convertDateFrom(date)),
                OthMsg: 'J',
                Credit: !window.cn(jvEntryData?.credit) ? jvEntryData?.credit : 0,
                Debit: !window.cn(jvEntryData?.debit) ? jvEntryData?.debit : 0,
                AccSrNo: jvEntryData?.accName.code,
                Message: jvEntryData?.remark,
                AccNm: jvEntryData?.accName.name,
                RefNo: voucher
            });

            setJVEntryList(tempJVEntryList);
            setJVEntryData({
                accName: jvEntryData?.accName,
                remark: '',
                debit: null,
                credit: null
            });
            setType(null);
            setIsJVUiUpdated(true);
            getAllTotals();
        }
    };

    // Get all totals
    const getAllTotals = () => {
        let creditTotal = 0;
        let debitTotal = 0;

        if (!window.cn(jvEntryList)) {
            jvEntryList.length > 0 &&
                jvEntryList.map((item: any) => (
                    <>
                        {(creditTotal += !window.cn(item.Credit) ? Number(item.Credit) : 0)}
                        {(debitTotal += !window.cn(item.Debit) ? Number(item.Debit) : 0)}
                    </>
                ));
        }

        setCredit(creditTotal);
        setDebit(debitTotal);
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Delete JV entry
    const deleteJVEntry = () => {
        jvEntryList.splice(deleteId, 1);
        getAllTotals();
        setIsJVUiUpdated(true);
        setDeleteId(null);
        setDeleteModal(false);
        toast.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: 'JV Entry Deleted'
        });
    };

    // Template for action
    const actionTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger" onClick={() => openDeleteModal(rowIndex.rowIndex)} />
                </div>
            </>
        );
    };

    // Datatable footer group
    const footerGroup = () => {
        return jvEntryList.length > 0 ? (
            <ColumnGroup>
                <Row>
                    <Column footer={<b>Total:</b>} colSpan={1} footerStyle={{ textAlign: 'left' }} />
                    <Column footer={<b>{amountFormate(credit) + '.00'}</b>} />
                    <Column footer={<b>{amountFormate(debit) + '.00'}</b>} />
                    <Column footer={''} colSpan={2} />
                </Row>
            </ColumnGroup>
        ) : (
            <></>
        );
    };

    // JV entry ui
    const jvEntryUI = () => {
        return (
            <>
                {/* Datatable */}
                <DataTable
                    value={jvEntryList}
                    showGridlines
                    stripedRows
                    rows={defaultRowOptions}
                    paginator={jvEntryList.length >= 10 && true}
                    rowsPerPageOptions={defaultPageRowOptions}
                    className="datatable-responsive p-datatable-sm"
                    paginatorTemplate={paginatorLinks}
                    currentPageReportTemplate={showingEntries}
                    emptyMessage="No Data Found"
                    footerColumnGroup={footerGroup()}
                >
                    {JVEntryAddListColumns.map((col, i) => {
                        if (col.field === 'action') {
                            return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                        } else if (col.field === 'Message') {
                            return <Column key={col.field} field={col.field} header={col.header} body={remarkTemplate} />;
                        } else if (col.field === 'Debit') {
                            return <Column key={col.field} field={col.field} header={col.header} body={debitTemplate} />;
                        } else if (col.field === 'Credit') {
                            return <Column key={col.field} field={col.field} header={col.header} body={creditTemplate} />;
                        } else {
                            return <Column key={col.field} field={col.field} header={col.header} />;
                        }
                    })}
                </DataTable>
            </>
        );
    };

    // Save JV Entry
    const saveJVEntry = async () => {
        try {
            setSubmitLoading(true);

            // Delete Account Name from Array
            jvEntryList.forEach((item: any) => delete item.AccNm);

            //apicall
            const response = await postAllData(SAVEJVENTRY, jvEntryList);
            if (response && !window.cn(response)) {
                setSubmitLoading(false);
                getVoucher(convertSingleYear(date));

                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response.data
                });
                setJVEntryList([]);
                setJVEntryData({});
                setCredit(null);
                setDebit(null);

            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Account'} pageName={'Add JV Entry'} pageTitle={'Add JV Entry'} goToPage={true} />
            <div className="card">
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-12">
                        {!window.cn(voucher) ? (
                            <>
                                <Tag className="mb-2" severity="info" value={'Voucher : ' + voucher}></Tag>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="date">
                            Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Calendar
                                value={date}
                                dateFormat="dd-M-yy"
                                onChange={(e: any) => {
                                    handleChangeDate(e.value);
                                }}
                                showIcon
                            />
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="accName">
                            Acc Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={jvEntryData?.accName}
                                name="accName"
                                options={accounts}
                                filter
                                optionLabel="name"
                                placeholder="Select Account"
                                onChange={(e) => onInputChange(e.value, 'accName')}
                                className={errors['accName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['accName']}</small>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="role">Type *</label>
                        <Dropdown filter value={type} onChange={(e) => setType(e.value)} options={ACCOUNTTYPE} optionLabel="name" name="type" placeholder="Select Type" className={errors['type'] && 'p-invalid'}></Dropdown>
                        <small className="p-invalid-txt">{errors['type']}</small>
                    </div>
                    {type?.code === 'credit' ? (
                        <div className="field col-12 md:col-6">
                            <label htmlFor="credit">
                                Credit Amount <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputNumber value={jvEntryData?.credit} name="credit" useGrouping={false} placeholder="Enter Credit Amount" onChange={(e) => onInputChange(e, 'credit')} className={errors['credit'] && 'p-invalid'} />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['credit']}</small>
                        </div>
                    ) : (
                        ''
                    )}

                    {type?.code === 'debit' ? (
                        <div className="field col-12 md:col-6">
                            <label htmlFor="debit">
                                Debit Amount <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputNumber value={jvEntryData?.debit} name="debit" useGrouping={false} placeholder="Enter Debit Amount" onChange={(e) => onInputChange(e, 'debit')} className={errors['debit'] && 'p-invalid'} />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['debit']}</small>
                        </div>
                    ) : (
                        ''
                    )}

                    <div className="field col-12 md:col-6">
                        <label htmlFor="remark">
                            Remark <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputTextarea rows={5} cols={30} value={jvEntryData?.remark} onChange={(e) => onInputChange(e, 'remark')} autoComplete="off" id="Address" />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['remark']}</small>
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 5 }}>
                            <Button label="clear" className="p-button-secondary" icon="pi pi-times" onClick={() => clearAll()} />
                            <Button label="Save" icon="pi pi-check" className="p-button-secondary" onClick={() => saveJVEntry()} loading={submitLoading} disabled={credit !== debit ? true : false || !window.cn(credit && debit) ? false : true} />
                            <Button label="Add" icon="pi pi-plus" onClick={() => addJvEntry()} />
                        </div>
                    </div>
                </div>
                <hr />
                <div className="mb-2">
                    <Tag className="mb-2" severity="warning" value={'Account year : ' + accYear}></Tag>
                </div>
                {jvEntryUI()}
            </div>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete JV Entry"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteJVEntry} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this JV Entry, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
